import * as Sentry from '@sentry/gatsby'
import { getCurrentEnv } from './config'

Sentry.init({
  dsn: 'https://df8c603a56610ab3b49525b5a3ced6d5@o280551.ingest.us.sentry.io/4506893854113792',
  integrations: [new Sentry.Replay()],
  tracesSampleRate: 0.1,
  // Capture Replay for 1% of all sessions,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 0.01,
  profilesSampleRate: 0.0,
  environment: getCurrentEnv(),
  enabled: getCurrentEnv() !== 'LOCAL',
})
